// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__4kg7r","fadeIn":"Spinner_fadeIn__RpxxF","loader":"Spinner_loader__MCCu0","load4":"Spinner_load4__0uM02"};